import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IClientPortalUsersService } from "services/ClientPortalUsersService";
import { ExternalPasswordChangeModel } from "services/api/cplauthapi/CPLAuthAPI";
import { RootState } from "setup/redux/RootReducer";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";

const initialState = {
  Loading: false,
  ActionSuccessful: false,
};

export const externalAccessSlice = createSlice({
  name: "externalAccess",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(externalPasswordChange.pending, (state) => {
        state.Loading = true;
      })
      .addCase(externalPasswordChange.rejected, (state) => {
        state.Loading = false;
      })
      .addCase(externalPasswordChange.fulfilled, (state) => {
        state.Loading = false;
        state.ActionSuccessful = true;
      });
  },
});

export const externalPasswordChange = createAsyncThunk<
  void,
  { passwordModel: ExternalPasswordChangeModel },
  { state: RootState }
>("ExternalAccessPasswordChange/ExternalPasswordChange", async ({ passwordModel }) => {
  const usersService = container.get<IClientPortalUsersService>(SERVICE_TYPES.ClientPortalUsersService);
  await usersService.externalPasswordChange(passwordModel);
});

export const selectLoading = (state: RootState) => state.externalAccess.Loading;
export const selectActionSuccessful = (state: RootState) => state.externalAccess.ActionSuccessful;

export default externalAccessSlice.reducer;
